<template>
  <div class="app-headers-view">
    <el-row>
      <el-col :span="5">
        <img class="head_img" src="../../assets/img/newIndex/logo_my.jpg">
      </el-col>
      <el-col :span="11">
        <div class="head_txt">济南市历城区<br/>精神卫生防治中心</div>
      </el-col>
      <el-col :span="5">
        <div style="height: 72px;float: left;line-height: 12px;padding-top:14px;font-size: 8px;font-family: KaiTi;color: rgb(227, 2, 18);font-weight: 700;/* margin-left: -20px; */">
          <div style="text-align: left">
            值班电话：<br/>0531-82818064
            <br/>
            技术联系：<br/>13793122175</div>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="hide_menu_but" @click="hideMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </el-col>
    </el-row>
    <div id="myMenuPet_div" @click="hideMenu"></div>
    <el-menu id="myMenu" class="my_el_menu" :default-active="activeUrl" :unique-opened="true">
      <div class="menu_title">网站导航
        <div class="close_but" @click="hideMenu">X</div>
      </div>
      <template v-for="(menu,index) in routes[1].children" v-if="!menu.hidden">
        <el-submenu :index="menu.path" :key="index" v-if="menu.children&&!menu.hidden">
          <span slot="title">{{menu.name}}</span>
          <el-menu-item v-show="!child.hidden" :index="child.path" :key="index2" v-for="(child,index2) in menu.children"
                        @click="toAnyPage(child.path)">
            {{child.name}}
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="menu.path" :key="index" v-else="menu.children&&!menu.hidden"
                      @click="toAnyPage(menu.path)">{{menu.name}}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import getters from "@/store/getters";
  import {constantRouterMapApp} from "@/router"

  export default {
    name: "HeaderView",
    data() {
      return {
        activeIndex: '1',
        isCollapse: false
      }
    },
    props: {
      routes: {
        type: Array
      }
    },
    methods: {
      navClick(index) {
        this.navIndex = index;
        document.cookie = "navIndex=" + index + ";";
        this.$emit("appStyle", index);
      },
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
      },
      hideMenu: function () {
        if (!this.isCollapse) {
          document.getElementById("myMenu").style.width = "50%";
          document.getElementById("myMenuPet_div").style.display = "block";
          this.isCollapse = true;
        } else {
          document.getElementById("myMenu").style.width = "0%";
          document.getElementById("myMenuPet_div").style.display = "none";
          this.isCollapse = false;
        }
      },
      toAnyPage: function (path) {
        this.$router.push(path);
        this.hideMenu();
      }
    },
    mounted() {
      this.$store.dispatch('setActiveIndex', this.$route.path.split("/")[2]);
      this.$store.dispatch('setActiveUrl', this.$route.path);
      this.$store.dispatch('setBreadcrumb', this.$route.matched.slice(-2));
    },
    computed: {
      activeUrl() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
        return this.$store.getters.getActiveUrl;
      },
      // 获取登录用户信息
      currentName() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
        return sessionStorage.getItem("username")
      },
    }
  }
</script>

<style lang="scss">
  .head_img {
    width: 70%;
    height: 70%;
    margin: 12% 10%;
  }

  .head_txt {
    font-size: 1.2rem;
    line-height: 1.9rem;
    height: 90%;
    margin: 5% 0;
    font-family: KaiTi;
    color: #e30212;
    font-weight: 700;
  }

  .hide_menu_but {
    background: #ffffff;
    width: 2.5rem;
    height: 2.5rem;
    margin-top: 5%;
    position: fixed;
    z-index: 4;
    border-radius: 5px;
    span {
      display: block;
      height: 4px;
      background: #0096ff;
      margin: 7px 4px;
    }
  }

  #myMenuPet_div {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 9;
    display: none;
  }

  .my_el_menu {
    width: 0%;
    height: 100%;
    position: fixed !important;
    right: 0;
    top: 0;
    border-right: none !important;
    background: #0087cd !important;
    transition: all 0.6s;
    overflow-y: auto;
    z-index: 10;

    .menu_title {
      background: #003e7d;
      height: 4rem;
      line-height: 4rem;
      font-size: 1.6rem;
      font-weight: 700;
      color: #ffffff;
      padding-left: 1rem;
      overflow: hidden;

      .close_but {
        float: right;
        width: 15%;
        text-align: center;
        font-weight: 500;
      }
    }

    .el-menu {
      background: #0087cd !important;
    }

    .el-menu-item {
      color: #ffffff;
    }

    .is-active {
      color: #e5f30d;
      background: #0087cd;
    }

    .el-submenu__title {
      color: #ffffff;

      i {
        color: #ffffff;
      }
    }

    .el-submenu__title:hover {
      background-color: #0087cd;
    }
  }
</style>
<style>
  html, body, head, div {
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/headerView/AppHeaderView.vue